/**
 * JSON Schema to Zod 변환 시 사용할 에러 메시지 설정
 *
 * 모든 변환기에서 공유하는 타입 및 기본 메시지 정의
 */

/** 에러 메시지 생성 함수 타입 */
type MessageFn = (value: number) => string

/** 에러 메시지 설정 인터페이스 */
export interface ErrorMessageConfig {
	/** 문자열 검증 메시지 */
	string?: {
		min?: string | MessageFn
		max?: string | MessageFn
		pattern?: string
	}
	/** 숫자 검증 메시지 */
	number?: {
		min?: string | MessageFn
		max?: string | MessageFn
		int?: string
	}
	/** 배열 검증 메시지 */
	array?: {
		min?: string | MessageFn
		max?: string | MessageFn
	}
	/** 필수 필드 메시지 */
	required?: string
}

/**
 * 메시지 값을 문자열로 변환
 */
export function resolveMessage(message: string | MessageFn | undefined, value: number, fallback: string): string {
	if (message === undefined) return fallback
	if (typeof message === "function") return message(value)
	return message
}

/**
 * 기본 한국어 에러 메시지
 */
export const defaultKoreanMessages: ErrorMessageConfig = {
	string: {
		min: (n) => `최소 ${n}자 이상이어야 합니다`,
		max: (n) => `최대 ${n}자까지 입력 가능합니다`,
		pattern: "유효한 형식이 아닙니다"
	},
	number: {
		min: (n) => `최소 ${n} 이상이어야 합니다`,
		max: (n) => `최대 ${n}까지 입력 가능합니다`,
		int: "정수를 입력해주세요"
	},
	array: {
		min: (n) => `최소 ${n}개 이상이어야 합니다`,
		max: (n) => `최대 ${n}개까지 가능합니다`
	},
	required: "필수 항목입니다"
}

/**
 * 기본 영어 에러 메시지
 */
export const defaultEnglishMessages: ErrorMessageConfig = {
	string: {
		min: (n) => `Must be at least ${n} characters`,
		max: (n) => `Must be at most ${n} characters`,
		pattern: "Invalid format"
	},
	number: {
		min: (n) => `Must be at least ${n}`,
		max: (n) => `Must be at most ${n}`,
		int: "Must be an integer"
	},
	array: {
		min: (n) => `Must have at least ${n} items`,
		max: (n) => `Must have at most ${n} items`
	},
	required: "This field is required"
}
